import { AssignedProperty, Assignee } from 'api/clients/PropertyClient'
import { FetchRequestState } from 'types'

export enum Actions {
  UPSERT_FILES_PROPERTIES = 'UPSERT_FILES_PROPERTIES',
  SET_FILES_PROPERTIES_LOADING_STATE = 'SET_FILES_PROPERTIES_LOADING_STATE',
  DELETE_FILES_PROPERTIES = 'DELETE_FILES_PROPERTIES',
}

export function setFilesPropertiesLoadingState(
  assignees: Assignee[],
  propertiesIds: number[],
  loadingState: FetchRequestState,
) {
  return {
    type: Actions.SET_FILES_PROPERTIES_LOADING_STATE,
    payload: { assignees, propertiesIds, loadingState },
  }
}

export function upsertFilesProperties(assignedProperties: AssignedProperty[]) {
  return {
    type: Actions.UPSERT_FILES_PROPERTIES,
    payload: { assignedProperties },
  }
}

export function deleteFilesProperties(assignees: Assignee[], propertyId: number) {
  return {
    type: Actions.DELETE_FILES_PROPERTIES,
    payload: { assignees, propertyId },
  }
}
